import { forwardRef, useImperativeHandle } from 'react';

const QuestionVideoRecording = forwardRef((props, ref) => {

    return (<></>);
});

export default QuestionVideoRecording;